import React from "react";
import { Box, Typography } from "@mui/material";

import { Usage } from "fond/types";

import PremsUsageChart from "../InsightsChart/PremsUsageChart";

import { CardHeader } from "./insightsOverview.styles";

interface InsightsOverviewProps {
  subscriptionUsage?: Usage;
}
const InsightsOverview: React.FC<InsightsOverviewProps> = ({ subscriptionUsage }: InsightsOverviewProps) => {
  return (
    <Box>
      <CardHeader>
        <Typography variant="body1" fontWeight={500}>
          Overview
        </Typography>
      </CardHeader>
      <PremsUsageChart subscriptionUsage={subscriptionUsage} />
    </Box>
  );
};

export default InsightsOverview;
